/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./prepend-actions.vue?vue&type=template&id=1b3ad20a&"
import script from "./prepend-actions.vue?vue&type=script&lang=ts&"
export * from "./prepend-actions.vue?vue&type=script&lang=ts&"
import style0 from "./prepend-actions.vue?vue&type=style&index=0&id=1b3ad20a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports